import { Badge, HStack, Text, VStack } from '@elkaso-app/web-design';

interface BrandInfoCellProps {
  name: string;
  image: string | null;
  countryCode: string;
}

export const BrandInfoCell: React.FC<BrandInfoCellProps> = ({ name, image, countryCode }) => (
  <div style={{ height: '100px', display: 'flex', alignItems: 'center', padding: '8px 0' }}>
    <HStack spacing={3}>
      {image && (
        <div style={{ width: '40px', height: '40px', borderRadius: '8px', overflow: 'hidden' }}>
          <img
            src={image}
            alt={name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )}
      <VStack align='start' spacing={1}>
        <Text fontWeight='medium' fontSize='md' color='gray.800' lineHeight='1.2'>
          {name}
        </Text>
        <Badge colorScheme='gray' variant='subtle' size='sm'>
          {countryCode}
        </Badge>
      </VStack>
    </HStack>
  </div>
);
